module.exports = __webpack_public_path__ + "img/logo-qcsnet.eaf04c96.png";